import i18n from '../../managers/i18n'

i18n.register(
  'en-US',
  {
    pageIndex: 'Page {index}',
    prev: 'Previous page',
    next: 'Next page',
    detail: 'Page {index} of {total}'
  },
  {
    ns: 'carousel'
  }
)
